import { actions as authActions } from '@saucelabs/sl-container-authentication';

import * as actions from './actions';

export const initializeEmbedded = () => (dispatch) => (
  Promise.all([
    // for anonymous user it will return 401, but we still want to show embed
    dispatch(authActions.getWhoami(null, { skipErrorPage: true })).catch(() => null),
  ])
    .then(() => {
      dispatch(actions.initialize());
    })
);
